import { VsInfiniteScroll } from '@vuesax-plus/components/infinite-scroll'
// import { VsLoading } from '@vuesax-plus/components/loading'
// import { VsNotification } from '@vuesax-plus/components/notification'

import type { Plugin } from 'vue'

export default [
  VsInfiniteScroll,
  // VsLoading,
  // VsNotification,
] as Plugin[]
